import React from 'react';
import { string } from 'prop-types';
import { Typography, Button, Tooltip } from '@one-thd/sui-atomic-components';
import { ServicePro, InfoFilled } from '@one-thd/sui-icons';
import { triggerViewAccountDashboardClick } from '../utils/analyticsEvents';

const TOOLTIP = 'Find your most recent Orders, Projects, Lists, and Quotes all in one place.';

export const ProAlertsAndUpdatesHeader = ({ componentId = '' }) => {
  const viewAccountDashboardClick = () => {
    triggerViewAccountDashboardClick(componentId);
  };

  return (
    <div className="sui-flex sui-items-center sui-justify-between sui-bg-inverse sui-px-4 sui-py-3 sui-rounded-t-base">
      <div className="sui-flex sui-items-center sui-gap-3 sui-min-w-0">
        <ServicePro size="large" color="brand" />
        <span className="sui-whitespace-nowrap">
          <Typography variant="h4" weight="display" color="inverse">Dashboard Snapshot</Typography>
        </span>
        <Tooltip title={TOOLTIP} placement="top-start">
          <button
            type="button"
            aria-label={TOOLTIP}
            className="sui-flex sui-items-center sui-bg-transparent sui-border-0 sui-p-0 sui-cursor-pointer"
          >
            <InfoFilled size="small" color="info" />
          </button>
        </Tooltip>
      </div>
      <span
        className="sui-hidden sm:sui-block sui-flex-shrink-0"
        style={{ '--sui-palette-outline-accent': 'var(--sui-palette-neutral-0)' }}
      >
        <Button onClick={viewAccountDashboardClick} variant="secondary" href="/myaccount/dashboard">
          <Typography
            component="span"
            variant="body-sm"
            weight="regular"
            height="tight"
            color="inverse"
          >
            View Account Dashboard
          </Typography>
        </Button>
      </span>
    </div>
  );
};

ProAlertsAndUpdatesHeader.propTypes = {
  componentId: string,
};

ProAlertsAndUpdatesHeader.displayName = 'ProAlertsAndUpdatesHeader';
